// ManagerOnlineHint — shown on personal pages (my-roster, my-leave, my-swaps)
// for managers/team-leads to remind them their team-management work lives on
// the desktop site.
import { Globe, ExternalLink } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { useI18n } from "@/i18n/I18nContext";

export default function ManagerOnlineHint() {
  // Hint is disabled — managers/teamleads now have full mobile functionality
  // (Team vandaag, Snel toewijzen, Aanvragen). No need to nudge them to desktop.
  return null;
}
